import create from 'zustand'

export const useSideSheetStore = create((set) => ({
  open: false,
  children: null,
  title: null,
  setOpen: (val, title, children) => set((state) => ({ ...state, open: val, title, children })),
  setOnlyOpen: (val) => set((state) => ({ ...state, open: val })),
  showOpen: (val, title, children) => set((state) => ({ ...state, open: val, title, children })),
}))